export const messages = {
  en: {
    groupBuyProduct: {
      title: 'Group Buy Product Management',
      queryConditions: 'Query Conditions',
      productName: 'Product Name',
      keyword: 'Keyword',
      barcode: 'Barcode',
      query: 'Query',
      reset: 'Reset',
      groupBuyList: 'Group Buy List',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      currentBatch: 'Current Batch',
      productId: 'Product ID',
      productImage: 'Product Image',
      groupName: 'Group Name',
      groupSize: 'Group Size',
      stock: 'Stock',
      participants: 'Participants',
      sort: 'Sort',
      status: 'Status',
      operations: 'Operations',
      active: 'Active',
      inactive: 'Inactive',
      groupInfo: 'Group Info',
      product: 'Product',
      required: 'Required',
      groupDesc: 'Group Description',
      productSpecs: 'Product Specifications',
      specName: 'Spec Name',
      specValue: 'Spec Value',
      sales: 'Sales',
      price: 'Price',
      costPrice: 'Cost Price',
      groupPrice: 'Group Price',
      groupStock: 'Group Stock',
      productExtension: 'Product Extension',
      activityStatus: 'Activity Status',
      productDetail: 'Product Detail',
      cancel: 'Cancel',
      save: 'Save',
      confirmDelete: 'Confirm Delete',
      deleteTip: 'Are you sure to delete this group buy product?',
      deleteSuccess: 'Delete Success',
      addSuccess: 'Add Success',
      updateSuccess: 'Update Success'
    }
  },
  zh: {
    groupBuyProduct: {
      title: '拼团商品管理',
      queryConditions: '查询条件',
      productName: '商品名称',
      keyword: '关键字',
      barcode: '产品条码',
      query: '查询',
      reset: '重置',
      groupBuyList: '拼团商品列表',
      add: '添加',
      edit: '修改',
      delete: '删除',
      currentBatch: '当前批次',
      productId: '商品ID',
      productImage: '商品图片',
      groupName: '拼团名称',
      groupSize: '拼团人数',
      stock: '库存',
      participants: '参与人数',
      sort: '排序',
      status: '状态',
      operations: '操作',
      active: '开启',
      inactive: '关闭',
      groupInfo: '拼团信息',
      product: '商品',
      required: '必填',
      groupDesc: '拼团简介',
      productSpecs: '商品规格',
      specName: '规格名称',
      specValue: '规格值',
      sales: '销量',
      price: '金额',
      costPrice: '成本价',
      groupPrice: '拼团价',
      groupStock: '拼团库存',
      productExtension: '商品扩展',
      activityStatus: '活动状态',
      productDetail: '商品详情',
      cancel: '取消',
      save: '保存',
      confirmDelete: '确认删除',
      deleteTip: '确定删除拼团商品信息',
      deleteSuccess: '删除成功',
      addSuccess: '添加成功',
      updateSuccess: '修改成功'
    }
  }
}